<template>
    <input class="e-field e-boolcell e-input" type="checkbox" v-model="column" :id="`grid_${data.column.uid}_${data.column.index}${data.column.field}`"  :name="data.column.field" e-mappinguid="grid-column85" />
</template>

<script>
export default {
  name: "booleanEditTemplate",
  props: {
  },
};

</script>

<style>
</style>